import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CartCopy from '../components/CartCopy'
import { actionCreators as cartActionCreators } from '../actions'
import { actionCreators as orderActionCreators } from '../../order/actions'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...cartActionCreators, ...orderActionCreators },
    dispatch
  )

const mapStateToProps = (state) => ({
  readyToRedirect: !!(state._persist && state._persist.rehydrated),
})

export default connect(mapStateToProps, mapDispatchToProps)(CartCopy)
